export default [
  {
    // Focus directive. Adding v-focus attribute to an element will focus it when inserted
    // You can also provide a value, changing the value will retrigger Focus
    //    Value added because keep-alive doesn't reinsert elements
    name: "focus",
    directive: {
      update(el, binding) {
        if (binding.value !== binding.oldValue) {
          el.focus();
        }
      },
      inserted(el) {
        el.focus();
      }
    }
  }
]
